import React, { useContext, useState } from 'react';
import {
	FormImageUploaderNewContext,
	IFormImageUploaderNewContext,
	IMaxFileSizeMB,
} from '../../formImageUploaderNewState/formImageUploaderNewContext';
import { openBrowseFile } from 'utils/openBrowseFile';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { Icon, IconName } from 'components/Icon/Icon';
import { NewButton } from 'components/Button/NewButton/NewButton';
import Text from 'components/Text/Text';
import LoaderWithProps from 'components/Loader/LoaderWithProps';
import style from './MediaModal.module.scss';

interface IProps {
	maxFileSizeMB: IMaxFileSizeMB;
	noImageIconId: string;
	loading: boolean;
}

export const GifTabPane: React.FC<IProps> = ({ maxFileSizeMB, noImageIconId, loading }) => {
	const { pendingGif, setPendingGif, changeTypeOfErrorModalWindow } =
		useContext<IFormImageUploaderNewContext>(FormImageUploaderNewContext);
	const [loadingImageErrorInModal, setLoadingImageErrorInModal] = useState<boolean>(false);

	const handleGifChange = (files: FileList | null) => {
		setLoadingImageErrorInModal(false);
		const gifFile = files ? files[0] : '';
		if (!gifFile) {
			return;
		} else if (maxFileSizeMB.gif && gifFile.size > 1000 * 1000 * maxFileSizeMB.gif) {
			changeTypeOfErrorModalWindow('gifFileSizeExceeded');
		} else if (gifFile.type === 'image/gif') {
			setPendingGif({ file: gifFile, src: URL.createObjectURL(gifFile) });
		} else {
			changeTypeOfErrorModalWindow('invalidGifFormat');
		}
	};

	const handleUploadGif = () => {
		openBrowseFile({
			onChoose: handleGifChange,
			accept: '.gif',
		});
	};

	const showErrorImage = () => {
		setLoadingImageErrorInModal(true);
	};

	const renderGif = () => {
		if (loading) {
			return (
				<div className={style.loaderContainer}>
					<LoaderWithProps loaderSize="big" />
				</div>
			);
		}

		if (!pendingGif.src) {
			return (
				<div className={style.noImageContainer}>
					<svg className={style.noImageIcon}>
						<use xlinkHref={`${breadcrumbs}#${noImageIconId}`} />
					</svg>
				</div>
			);
		}

		if (loadingImageErrorInModal) {
			return (
				<div className={style.brokenImageContainer}>
					<svg className={style.brokenImageIcon}>
						<use xlinkHref={`${breadcrumbs}#brokenPicture`} />
					</svg>
					<div>Error image</div>
				</div>
			);
		}

		return <img className={style.imageContainer} src={pendingGif.src} onError={showErrorImage} alt="Gif" />;
	};

	return (
		<div className={style.tabPaneBody}>
			{renderGif()}
			{!loading && (
				<div className={style.tabButtons}>
					<div data-test="uploadGifButton">
						<NewButton
							variant="primary"
							color="purple"
							size="small"
							iconLeft={<Icon name={IconName.upload} />}
							onClick={handleUploadGif}>
							<Text translationNameSpace="form" translationKey="uploadGifButton" asFragment={true} />
						</NewButton>
					</div>
				</div>
			)}
		</div>
	);
};
